import { render, staticRenderFns } from "./MBtnNormalComp.vue?vue&type=template&id=71ce515b&"
import script from "./MBtnNormalComp.vue?vue&type=script&lang=js&"
export * from "./MBtnNormalComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports